import React, { useState } from 'react'
import { Button, Empty, Popconfirm } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faEdit, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'

//APP
import { mascaraOdom } from '../../../../../../services/Afins'
import { gerarKey, removerAcentos } from '../../../../../../utils'

//COMPONENTS
import Input from '../../../../../../Components/CustomUi/input'
import Carregando from '../../../../../../Components/CustomUi/loading'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { Box } from '../../../../../../Components/CustomUi/box'
import { Render } from '../../../../../../Components/CustomUi/render'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { Switcher } from '../../../../../../Components/CustomUi/Switcher'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import { AtribuicaoFrota } from '../../../../../../services/Patrimonio/atribuicaoFrota/GET'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'

//PROPS
interface Props {
    loading: boolean
    list_atribuicao: AtribuicaoFrota[]
    deletar: Function
    abrir: Function
    setPagination?: React.Dispatch<React.SetStateAction<number>>
    page?: number
    setPage?: React.Dispatch<React.SetStateAction<number>>
    buscarTabela: string
    setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
    confirmar_exclusao: boolean
    setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
    id_item_atual: number
    setId_item_atual: React.Dispatch<React.SetStateAction<number>>
    nome_item_atual: string
    setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
    fake_loading: boolean
    permissions: ItensPerUserLogged
    total: number
}

export const TabelaAtribuicao: React.FC<Props> = ({
    list_atribuicao,
    loading,
    deletar,
    abrir,
    setPagination,
    page,
    setPage,
    buscarTabela,
    setBuscarTabela,
    confirmar_exclusao,
    setConfirmar_exclusao,
    id_item_atual,
    setId_item_atual,
    nome_item_atual,
    setNome_item_atual,
    fake_loading,
    total,
    permissions
}) => {
    function buscarAtribuicao(buscar_nome: string) {
        const palavraSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const nomeSemAcentos = removerAcentos(String(item?.nome))
            return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    return (
        <Box style={{ height: 'calc(100vh - 170px)', border: 'none' }} padding={0} borderless>
            {/* <TitleH2>Lista de patrimônios</TitleH2> */}

            <Inline alignItems='center'>
                <Input placeholder='Buscar atribuição' value={buscarTabela} onChange={setBuscarTabela} />
                <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
                    Novo
                </ButtonCustom>
            </Inline>
            <HeaderTable
                itens={[
                    { valor: 'Nome', width: 'calc(100% - 615px)' },
                    { valor: 'Veiculo', width: '400px' },
                    { valor: 'Frota', width: '100px' },
                    { valor: 'Ações', width: '110px' },
                ]}
            />

            <BodyTable
                paginate={total}
                onChangeItensPage={setPagination}
                onChangePage={setPage}
                current_page={page}
                setCurrent_page={setPage}
                style={{
                    height: 'calc(100vh - 170px)',
                    // height: (list_atribuicao ?? []).length < 8 && 'calc(100vh - 170px)',
                    position: 'relative',
                    overflowX: 'hidden',
                    overflowY: 'scroll',
                    marginTop: -10,
                }}
            >
                <Render condition={!loading}>
                    {(list_atribuicao ?? [])
                        .filter(buscarAtribuicao(buscarTabela))
                        .map(
                            ({ cod_usuario, cod_veiculo, usuario_nome, veiculo_nome, frota }) => {
                                return (
                                    <RowTable key={cod_usuario} onDoubleClick={() => { }}>
                                        <RowItem width={'calc(100% - 610px)'}>{usuario_nome}</RowItem>
                                        <RowItem width={'400px'}>{veiculo_nome}</RowItem>
                                        <RowItem width={'100px'}>{frota}</RowItem>
                                        <RowItem width={'110px'}>
                                            <DeleteButton
                                                open={confirmar_exclusao && id_item_atual === cod_usuario}
                                                trigger={setConfirmar_exclusao}
                                                onTrigger={() => {
                                                    setId_item_atual(cod_usuario)
                                                    setNome_item_atual(usuario_nome)
                                                }}
                                                loading={fake_loading}
                                                message={`o item ${usuario_nome} será excluido!`}
                                                deleteds={[usuario_nome]}
                                                onDelete={() => {
                                                    deletar(cod_usuario, cod_veiculo)
                                                }}
                                                textButtonTrigger='Excluir'
                                                typeButtonTrigger='secondary'
                                                disabled={permissions?.exclusao === 0}
                                                disabledTrigger={permissions?.exclusao === 0}
                                            />

                                        </RowItem>
                                    </RowTable>
                                )
                            }
                        )}
                </Render>

                <Render condition={list_atribuicao?.length === 0 && !loading}>
                    {buscarTabela === '' ? (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<> Nenhum registro disponível!</>}
                        />
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <>
                                    {' '}
                                    <b>'{buscarTabela}'</b> não encontrado!
                                </>
                            }
                        />
                    )}
                </Render>

                <Render condition={loading}>
                    <Carregando
                        animation
                        legenda='Carregando patrimônios...'
                        justifyContent='center'
                        height={400}
                        size='default'
                    />
                </Render>
            </BodyTable>
        </Box>
    )
}